import React from "react";

/**
 * Expanded edit panel — shown below the action bar when "Edit" is toggled.
 * Contains: regen post, full regenerate, delete.
 * Image editing is handled via the per-image modal (BlogImageModal).
 */
const BlogEditPanel = ({
  busy,
  showRegenForm,
  setShowRegenForm,
  regenFeedback,
  setRegenFeedback,
  onRegenerate,
  onFullRegenerate,
  onDelete,
}) => (
  <div className="border-t border-gray-100 bg-gray-50 max-w-[860px] mx-auto px-4 py-4">
    {/* Edit post sub-section */}
    <div className="mb-3 p-4 bg-white border border-amber-200 rounded-lg">
      {!showRegenForm ? (
        <button
          onClick={() => setShowRegenForm(true)}
          className="text-sm text-amber-700 hover:text-amber-900 font-medium"
        >
          ✏️ Edit post…
        </button>
      ) : (
        <>
          <p className="text-sm font-medium text-amber-800 mb-2">Feedback for the AI (optional):</p>
          <textarea
            className="w-full border border-amber-300 rounded p-2 text-sm text-gray-800 mb-2 focus:outline-none focus:ring-2 focus:ring-amber-400"
            rows={2}
            placeholder="e.g. Make it shorter, focus on toddlers…"
            value={regenFeedback}
            onChange={e => setRegenFeedback(e.target.value)}
            style={{ color: "#1a1a2e" }}
          />
          <div className="flex gap-2">
            <button onClick={onRegenerate} className="px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded hover:bg-amber-700">Apply edits</button>
            <button onClick={() => setShowRegenForm(false)} className="px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded hover:bg-gray-300">Cancel</button>
          </div>
        </>
      )}
    </div>

    {/* Full regenerate */}
    <div className="mb-3 p-4 bg-white border border-orange-200 rounded-lg">
      <button
        onClick={onFullRegenerate}
        className="text-sm text-orange-700 hover:text-orange-900 font-medium"
      >
        ♻️ Regenerate from scratch…
      </button>
    </div>

    {/* Delete */}
    <button
      onClick={onDelete}
      className="text-sm text-red-600 hover:text-red-800 font-medium"
      disabled={busy}
    >
      🗑 Delete this post
    </button>
  </div>
);

export default BlogEditPanel;
